import {eventsReducer} from "./events/reducer";


export const reducers = {
    events: eventsReducer,
}